export function normalizeSummaryCell(cell) {
    if (typeof cell === 'function') {
        return { value: cell };
    }

    if (cell && typeof cell === 'object' && !Array.isArray(cell)) {
        return {
            id: cell.id || '',
            value: cell.value,
            format: cell.format,
            className: cell.className || '',
            placeholder: cell.placeholder
        };
    }

    return { value: cell };
}

export function normalizeSummaryRow(row) {
    const sourceCells = Array.isArray(row?.cells) ? row.cells : Array.isArray(row?.values) ? row.values : [];

    return {
        label: row?.label || '',
        className: row?.className || '',
        labelClassName: row?.labelClassName || '',
        cells: sourceCells.map(normalizeSummaryCell)
    };
}
